module.exports = __webpack_public_path__ + "img/banner_promo_sky_02.c7e3ccff.png";